export const locales = ['zh-TW', 'en', 'ko'] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'zh-TW';

export const localeNames: Record<Locale, string> = {
  'zh-TW': '中文',
  'en': 'EN',
  'ko': '한국어',
};

export const localeFlags: Record<Locale, string> = {
  'zh-TW': '🇹🇼',
  'en': '🇺🇸',
  'ko': '🇰🇷',
};
